import { css } from 'styled-components';

export const buttonColors = {
  light: {
    primary: {
      background: {
        default: 'var(--colour-component-buttons-light-primary-background-default)',
        hover: 'var(--colour-component-buttons-light-primary-background-hover)',
        pressed: 'var(--colour-component-buttons-light-primary-background-pressed)',
        disabled: 'var(--colour-component-buttons-light-primary-background-disabled)',
      },
      border: {
        default: 'var(--colour-component-buttons-light-primary-border-default)',
        hover: 'var(--colour-component-buttons-light-primary-border-hover)',
        pressed: 'var(--colour-component-buttons-light-primary-border-pressed)',
        disabled: 'var(--colour-component-buttons-light-primary-border-disabled)',
      },
      text: {
        default: 'var(--colour-component-buttons-light-primary-text-default)',
        hover: 'var(--colour-component-buttons-light-primary-text-hover)',
        pressed: 'var(--colour-component-buttons-light-primary-text-pressed)',
        disabled: 'var(--colour-component-buttons-light-primary-text-disabled)',
      },
      icon: {
        default: 'var(--colour-component-buttons-light-primary-icon-default)',
        hover: 'var(--colour-component-buttons-light-primary-icon-hover)',
        pressed: 'var(--colour-component-buttons-light-primary-icon-pressed)',
        disabled: 'var(--colour-component-buttons-light-primary-icon-disabled)',
      },
    },
    secondary: {
      background: {
        default: 'var(--colour-component-buttons-light-secondary-background-default)',
        hover: 'var(--colour-component-buttons-light-secondary-background-hover)',
        pressed: 'var(--colour-component-buttons-light-secondary-background-pressed)',
        disabled: 'var(--colour-component-buttons-light-secondary-background-disabled)',
      },
      border: {
        default: 'var(--colour-component-buttons-light-secondary-border-default)',
        hover: 'var(--colour-component-buttons-light-secondary-border-hover)',
        pressed: 'var(--colour-component-buttons-light-secondary-border-pressed)',
        disabled: 'var(--colour-component-buttons-light-secondary-border-disabled)',
      },
      text: {
        default: 'var(--colour-component-buttons-light-secondary-text-default)',
        hover: 'var(--colour-component-buttons-light-secondary-text-hover)',
        pressed: 'var(--colour-component-buttons-light-secondary-text-pressed)',
        disabled: 'var(--colour-component-buttons-light-secondary-text-disabled)',
      },
      icon: {
        default: 'var(--colour-component-buttons-light-secondary-icon-default)',
        hover: 'var(--colour-component-buttons-light-secondary-icon-hover)',
        pressed: 'var(--colour-component-buttons-light-secondary-icon-pressed)',
        disabled: 'var(--colour-component-buttons-light-secondary-icon-disabled)',
      },
    },
    tertiary: {
      text: {
        default: 'var(--colour-component-buttons-light-tertiary-text-default)',
        hover: 'var(--colour-component-buttons-light-tertiary-text-hover)',
        pressed: 'var(--colour-component-buttons-light-tertiary-text-pressed)',
        disabled: 'var(--colour-component-buttons-light-tertiary-text-disabled)',
      },
      icon: {
        default: 'var(--colour-component-buttons-light-tertiary-icon-default)',
        hover: 'var(--colour-component-buttons-light-tertiary-icon-hover)',
        pressed: 'var(--colour-component-buttons-light-tertiary-icon-pressed)',
        disabled: 'var(--colour-component-buttons-light-tertiary-icon-disabled)',
      },
    },
  },
  dark: {
    primary: {
      background: {
        default: 'var(--colour-component-buttons-dark-primary-background-default)',
        hover: 'var(--colour-component-buttons-dark-primary-background-hover)',
        pressed: 'var(--colour-component-buttons-dark-primary-background-pressed)',
        disabled: 'var(--colour-component-buttons-dark-primary-background-disabled)',
      },
      border: {
        default: 'var(--colour-component-buttons-dark-primary-border-default)',
        hover: 'var(--colour-component-buttons-dark-primary-border-hover)',
        pressed: 'var(--colour-component-buttons-dark-primary-border-pressed)',
        disabled: 'var(--colour-component-buttons-dark-primary-border-disabled)',
      },
      text: {
        default: 'var(--colour-component-buttons-dark-primary-text-default)',
        hover: 'var(--colour-component-buttons-dark-primary-text-hover)',
        pressed: 'var(--colour-component-buttons-dark-primary-text-pressed)',
        disabled: 'var(--colour-component-buttons-dark-primary-text-disabled)',
      },
      icon: {
        default: 'var(--colour-component-buttons-dark-primary-icon-default)',
        hover: 'var(--colour-component-buttons-dark-primary-icon-hover)',
        pressed: 'var(--colour-component-buttons-dark-primary-icon-pressed)',
        disabled: 'var(--colour-component-buttons-dark-primary-icon-disabled)',
      },
    },
    secondary: {
      background: {
        default: 'var(--colour-component-buttons-dark-secondary-background-default)',
        hover: 'var(--colour-component-buttons-dark-secondary-background-hover)',
        pressed: 'var(--colour-component-buttons-dark-secondary-background-pressed)',
        disabled: 'var(--colour-component-buttons-dark-secondary-background-disabled)',
      },
      border: {
        default: 'var(--colour-component-buttons-dark-secondary-border-default)',
        hover: 'var(--colour-component-buttons-dark-secondary-border-hover)',
        pressed: 'var(--colour-component-buttons-dark-secondary-border-pressed)',
        disabled: 'var(--colour-component-buttons-dark-secondary-border-disabled)',
      },
      text: {
        default: 'var(--colour-component-buttons-dark-secondary-text-default)',
        hover: 'var(--colour-component-buttons-dark-secondary-text-hover)',
        pressed: 'var(--colour-component-buttons-dark-secondary-text-pressed)',
        disabled: 'var(--colour-component-buttons-dark-secondary-text-disabled)',
      },
      icon: {
        default: 'var(--colour-component-buttons-dark-secondary-icon-default)',
        hover: 'var(--colour-component-buttons-dark-secondary-icon-hover)',
        pressed: 'var(--colour-component-buttons-dark-secondary-icon-pressed)',
        disabled: 'var(--colour-component-buttons-dark-secondary-icon-disabled)',
      },
    },
    tertiary: {
      text: {
        default: 'var(--colour-component-buttons-dark-tertiary-text-default)',
        hover: 'var(--colour-component-buttons-dark-tertiary-text-hover)',
        pressed: 'var(--colour-component-buttons-dark-tertiary-text-pressed)',
        disabled: 'var(--colour-component-buttons-dark-tertiary-text-disabled)',
      },
      icon: {
        default: 'var(--colour-component-buttons-dark-tertiary-icon-default)',
        hover: 'var(--colour-component-buttons-dark-tertiary-icon-hover)',
        pressed: 'var(--colour-component-buttons-dark-tertiary-icon-pressed)',
        disabled: 'var(--colour-component-buttons-dark-tertiary-icon-disabled)',
      },
    },
  },
};

export const buttonColorVariables = css`
  --colour-component-buttons-light-primary-background-default: var(--colour-role-bg-interactive);
  --colour-component-buttons-light-primary-background-hover: var(--colour-brand-midnight);
  --colour-component-buttons-light-primary-background-pressed: var(--colour-brand-midnight);
  --colour-component-buttons-light-primary-background-disabled: var(--colour-role-bg-disabled);
  --colour-component-buttons-light-primary-border-default: var(--colour-role-border-interactive);
  --colour-component-buttons-light-primary-border-hover: var(--colour-brand-midnight);
  --colour-component-buttons-light-primary-border-pressed: var(--colour-brand-midnight);
  --colour-component-buttons-light-primary-border-disabled: var(--colour-role-border-disabled);
  --colour-component-buttons-light-primary-text-default: var(--colour-brand-pure-white);
  --colour-component-buttons-light-primary-text-hover: var(--colour-brand-pure-white);
  --colour-component-buttons-light-primary-text-pressed: var(--colour-brand-pure-white);
  --colour-component-buttons-light-primary-text-disabled: var(--colour-role-text-disabled);
  --colour-component-buttons-light-primary-icon-default: var(--colour-brand-pure-white);
  --colour-component-buttons-light-primary-icon-hover: var(--colour-brand-pure-white);
  --colour-component-buttons-light-primary-icon-pressed: var(--colour-brand-pure-white);
  --colour-component-buttons-light-primary-icon-disabled: var(--colour-role-icon-disabled);

  --colour-component-buttons-light-secondary-background-default: var(--colour-brand-pure-white);
  --colour-component-buttons-light-secondary-background-hover: var(--colour-brand-sky-blue-100);
  --colour-component-buttons-light-secondary-background-pressed: var(--colour-brand-sky-blue-100);
  --colour-component-buttons-light-secondary-background-disabled: var(--colour-brand-pure-white);
  --colour-component-buttons-light-secondary-border-default: var(--colour-brand-bmo-blue);
  --colour-component-buttons-light-secondary-border-hover: var(--colour-brand-bmo-blue);
  --colour-component-buttons-light-secondary-border-pressed: var(--colour-brand-bmo-blue);
  --colour-component-buttons-light-secondary-border-disabled: var(--colour-role-border-disabled);
  --colour-component-buttons-light-secondary-text-default: var(--colour-brand-bmo-blue);
  --colour-component-buttons-light-secondary-text-hover: var(--colour-brand-bmo-blue);
  --colour-component-buttons-light-secondary-text-pressed: var(--colour-brand-bmo-blue);
  --colour-component-buttons-light-secondary-text-disabled: var(--colour-role-text-disabled);
  --colour-component-buttons-light-secondary-icon-default: var(--colour-brand-bmo-blue);
  --colour-component-buttons-light-secondary-icon-hover: var(--colour-brand-bmo-blue);
  --colour-component-buttons-light-secondary-icon-pressed: var(--colour-brand-bmo-blue);
  --colour-component-buttons-light-secondary-icon-disabled: var(--colour-role-icon-disabled);

  --colour-component-buttons-light-tertiary-text-default: var(--colour-role-text-interactive);
  --colour-component-buttons-light-tertiary-text-hover: var(--colour-brand-midnight);
  --colour-component-buttons-light-tertiary-text-pressed: var(--colour-brand-midnight);
  --colour-component-buttons-light-tertiary-text-disabled: var(--colour-role-text-disabled);
  --colour-component-buttons-light-tertiary-icon-default: var(--colour-brand-navy);
  --colour-component-buttons-light-tertiary-icon-hover: var(--colour-brand-navy);
  --colour-component-buttons-light-tertiary-icon-pressed: var(--colour-brand-navy);
  --colour-component-buttons-light-tertiary-icon-disabled: var(--colour-role-icon-disabled);

  --colour-component-buttons-dark-primary-background-default: var(--colour-brand-pure-white);
  --colour-component-buttons-dark-primary-background-hover: var(--colour-brand-midnight);
  --colour-component-buttons-dark-primary-background-pressed: var(--colour-brand-midnight);
  --colour-component-buttons-dark-primary-background-disabled: var(--colour-role-bg-disabled);
  --colour-component-buttons-dark-primary-border-default: var(--colour-brand-pure-white);
  --colour-component-buttons-dark-primary-border-hover: var(--colour-brand-midnight);
  --colour-component-buttons-dark-primary-border-pressed: var(--colour-brand-midnight);
  --colour-component-buttons-dark-primary-border-disabled: var(--colour-role-border-disabled);
  --colour-component-buttons-dark-primary-text-default: var(--colour-brand-bmo-blue);
  --colour-component-buttons-dark-primary-text-hover: var(--colour-brand-pure-white);
  --colour-component-buttons-dark-primary-text-pressed: var(--colour-brand-pure-white);
  --colour-component-buttons-dark-primary-text-disabled: var(--colour-role-text-disabled);
  --colour-component-buttons-dark-primary-icon-default: var(--colour-brand-bmo-blue);
  --colour-component-buttons-dark-primary-icon-hover: var(--colour-brand-pure-white);
  --colour-component-buttons-dark-primary-icon-pressed: var(--colour-brand-pure-white);
  --colour-component-buttons-dark-primary-icon-disabled: var(--colour-role-icon-disabled);

  --colour-component-buttons-dark-secondary-background-default: var(--colour-brand-bmo-blue);
  --colour-component-buttons-dark-secondary-background-hover: var(--colour-brand-sky-blue-100);
  --colour-component-buttons-dark-secondary-background-pressed: var(--colour-brand-sky-blue-100);
  --colour-component-buttons-dark-secondary-background-disabled: var(--colour-role-bg-disabled);
  --colour-component-buttons-dark-secondary-border-default: var(--colour-brand-pure-white);
  --colour-component-buttons-dark-secondary-border-hover: var(--colour-brand-pure-white);
  --colour-component-buttons-dark-secondary-border-pressed: var(--colour-brand-pure-white);
  --colour-component-buttons-dark-secondary-border-disabled: var(--colour-role-border-disabled);
  --colour-component-buttons-dark-secondary-text-default: var(--colour-brand-pure-white);
  --colour-component-buttons-dark-secondary-text-hover: var(--colour-brand-bmo-blue);
  --colour-component-buttons-dark-secondary-text-pressed: var(--colour-brand-bmo-blue);
  --colour-component-buttons-dark-secondary-text-disabled: var(--colour-role-text-disabled);
  --colour-component-buttons-dark-secondary-icon-default: var(--colour-brand-pure-white);
  --colour-component-buttons-dark-secondary-icon-hover: var(--colour-brand-bmo-blue);
  --colour-component-buttons-dark-secondary-icon-pressed: var(--colour-brand-bmo-blue);
  --colour-component-buttons-dark-secondary-icon-disabled: var(--colour-role-icon-disabled);

  --colour-component-buttons-dark-tertiary-text-default: var(--colour-brand-pure-white);
  --colour-component-buttons-dark-tertiary-text-hover: var(--colour-brand-sky-blue-200);
  --colour-component-buttons-dark-tertiary-text-pressed: var(--colour-brand-sky-blue-200);
  --colour-component-buttons-dark-tertiary-text-disabled: var(--colour-role-text-disabled);
  --colour-component-buttons-dark-tertiary-icon-default: var(--colour-brand-pure-white);
  --colour-component-buttons-dark-tertiary-icon-hover: var(--colour-brand-pure-white);
  --colour-component-buttons-dark-tertiary-icon-pressed: var(--colour-brand-pure-white);
  --colour-component-buttons-dark-tertiary-icon-disabled: var(--colour-role-icon-disabled);
`;
